const serviceCategoriesHandler = () => {
  const categoryNav = document.querySelector(
    ".service-archive__nav-buttons-wrapper"
  );

  if (categoryNav) {
    const navItems = categoryNav.querySelectorAll(".service-archive__nav-item");
    const url = window.location;
    const test = url.pathname.split("/").filter(Boolean)

    navItems.forEach((navItem) => {
      const slug = navItem.dataset.slug;

      if (url.href.includes(slug) && slug != "view-all") {
        navItem.classList.add("active");
      }

      if (test?.length === 1 && !url.search) {
        navItems[0].classList.add("active");
      }
    });
  }
};

if (document.readyState !== "loading") {
  serviceCategoriesHandler();
} else {
  document.addEventListener("DOMContentLoaded", serviceCategoriesHandler);
}
